module.exports = __webpack_public_path__ + "images/category_lp/alcohol/store_images/1_c53dba3497741d27c23111b92442ca7f.png";